import { useSelector } from "react-redux";
import { StateExtended } from "../../_config/interfaces/stateExtended";

export const useStatesSelector = () => useSelector((state: StateExtended) => state.master.states);
export const useAllCountySelector = () => useSelector((state: StateExtended) => state.master.allCounty);
export const useAllCitySelector = () => useSelector((state: StateExtended) => state.master.allCity);
export const useCountriesSelector = () => useSelector((state: StateExtended) => state.master.countries);
export const useLookupValuesSelector = () => useSelector((state: StateExtended) => state.master.lookupValues);
export const useLocationsSelector = () => useSelector((state: StateExtended) => state.master.locations);
export const useCurrencyListSelector = () => useSelector((state: StateExtended) => state.master.currencyList);
export const useTimezoneSelector = () => useSelector((state: StateExtended) => state.master.timezones);
export const useReturnReasonsSelector = () => useSelector((state: StateExtended) => state.master.returnReasons);
